// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folders-solid';

export const Component = () => (
  <path d='M23.563 8.813H21.6V3.926c0-.239-.096-.479-.288-.718-.239-.192-.478-.288-.718-.288H9.818L9.052.671C8.908.238 8.572 0 8.142 0H.957a.946.946 0 0 0-.67.287.946.946 0 0 0-.288.67v16.716c0 .239.096.479.287.67a.946.946 0 0 0 .67.287H2.92v4.886c0 .287.096.526.335.718a.946.946 0 0 0 .67.288h19.637a.945.945 0 0 0 .67-.288.976.976 0 0 0 .287-.718V9.818a.977.977 0 0 0-.287-.719.943.943 0 0 0-.67-.287Zm-2.97-4.886v4.886H12.74l-.766-2.251c-.144-.432-.432-.67-.91-.67H3.926a.946.946 0 0 0-.67.287.837.837 0 0 0-.336.67v10.824H.958V.958H8.14l.958 2.97h11.495Z' />
);

export const viewBox = '0 0 25 25';
